/**
 * useCreditDetail
 * Fetches credit detail with amortization schedule from /backoffice/credits/{creditId}
 */
import { useQuery } from '@tanstack/react-query';
import { getCreditDetail } from '@/services/credit-engine.service';

export function useCreditDetail(creditId: string, directoryId: string) {
  const query = useQuery({
    queryKey: ['backoffice', 'credits', creditId, directoryId],
    queryFn: () => getCreditDetail(creditId, directoryId),
    enabled: Boolean(creditId && directoryId),
  });

  return {
    credit: query.data?.data?.credit ?? null,
    schedule: query.data?.data?.schedule ?? [],
    user: query.data?.data?.user ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
